"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _spaui = require("@tencent/spaui");

var _helper = require("../helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SearchComponent = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SearchComponent, _React$PureComponent);

  function SearchComponent(props) {
    var _this;

    _classCallCheck(this, SearchComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchComponent).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onValueChange", function (_event, _value) {
      var value = _this.state.value;
      var trimedValue = String(_value || '').trim();

      if (trimedValue != value) {
        _this.setState({
          value: trimedValue
        });

        _this.props.onChange(_defineProperty({}, _this.key, trimedValue));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickSearchIcon", function () {
      _this.props.onChange(_defineProperty({}, _this.key, _this.state.value));
    });

    _defineProperty(_assertThisInitialized(_this), "onClear", function () {
      _this.setState({
        value: ''
      });

      _this.props.onChange(_defineProperty({}, _this.key, ''));
    });

    var _this$props = _this.props,
        tabKey = _this$props.tabKey,
        _this$props$state = _this$props.state,
        state = _this$props$state === void 0 ? {} : _this$props$state;
    _this.key = (0, _helper.getSeachStrByTab)(tabKey);
    _this.state = {
      value: state[_this.key]
    };
    return _this;
  }

  _createClass(SearchComponent, [{
    key: "render",
    value: function render() {
      var value = this.state.value;
      var placeholder = this.props.placeholder;
      return _react["default"].createElement("div", {
        className: "spaui-columns-search"
      }, _react["default"].createElement(_spaui.AutoComplete, {
        clearable: true,
        value: value,
        open: false,
        placeholder: placeholder,
        onChange: this.onValueChange,
        onClickSearchIcon: this.onClickSearchIcon,
        onClear: this.onClear,
        inputProps: {
          onBlur: this.onClickSearchIcon
        }
      }));
    }
  }]);

  return SearchComponent;
}(_react["default"].PureComponent);

var _default = SearchComponent;
exports["default"] = _default;